import { render } from "./Unauthorized.vue?vue&type=template&id=34dfc1a4&scoped=true"
import script from "./Unauthorized.vue?vue&type=script&lang=js"
export * from "./Unauthorized.vue?vue&type=script&lang=js"

import "./Unauthorized.vue?vue&type=style&index=0&id=34dfc1a4&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34dfc1a4"]])

export default __exports__